import { toast } from "react-toastify";

export const notify = (type, message, delay) => {
  if (type === "success") {
    toast.success(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      delay,
    });
  } else if (type === "error") {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      delay,
    });
  } else if (type === "warn") {
    toast.warn(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      delay,
    });
  } else {
    toast.info(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      delay,
    });
  }
};

export const ProposalDateDiff = function (date) {
  let cDate = new Date()
  date = new Date(date)
  let utcThis = Date.UTC(cDate.getFullYear(), cDate.getMonth(), cDate.getDate(), cDate.getHours(), cDate.getMinutes(), cDate.getSeconds());
  let utcOther = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());

  let h = (utcThis - utcOther) / 3600000;
  console.log(utcThis,utcOther,h)
  if(h>=0 && h<=24){    console.log("false")

    return true
  }else{   console.log("true")

    return false
  }
};


export const myDateFormat = (indate='', datetime=false, saveDt=false) => {
  let dateNow = new Date();
  if(indate!=''){ dateNow = new Date(indate); }

  let dd = dateNow.getDate();
  let monthSingleDigit = dateNow.getMonth() + 1,
      mm = monthSingleDigit < 10 ? '0' + monthSingleDigit : monthSingleDigit;
      dd = dd < 10 ? '0' + dd : dd;
  let yyyy = dateNow.getFullYear();

  let hh = dateNow.getHours();
  hh = hh < 10 ? '0' + hh : hh;
  let mts = dateNow.getMinutes();
  mts = mts < 10 ? '0' + mts : mts;
  let ss = dateNow.getSeconds();
  ss = ss < 10 ? '0' + ss : ss;

  if(saveDt) return (yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mts + ':' + ss);
  if(datetime) return (dd + '-' + mm + '-' + yyyy + ' ' + hh + ':' + mts + ':' + ss);
  return (yyyy + '-' + mm + '-' + dd );
}

export const dateFormat2 = (indate,istime=false) => {
  let dateNow = new Date();
  if(indate!=''){ dateNow = new Date(indate); }

  let dt = dateNow.toLocaleDateString('en-GB')

  let hh = dateNow.getHours();
      hh = hh < 10 ? '0' + hh : hh;
  let mts = dateNow.getMinutes();
      mts = mts < 10 ? '0' + mts : mts;
  let ss = dateNow.getSeconds();
      ss = ss < 10 ? '0' + ss : ss;

  if(istime) return dt = dt +'  '+hh+':'+mts+':'+ss
  return dt
}